import React, { useState } from "react";
import { Container, TextField, Button, Grid, Typography, Box } from "@mui/material";
import { LocationOn, Phone, Email } from "@mui/icons-material";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Formulário enviado:", formData);
    // Aqui você pode fazer a requisição para o backend para enviar o e-mail
  };

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "10vh",
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 4 },
        background: "linear-gradient(135deg, #f6f0ff 0%, #ffffff 45%, #f0f4ff 100%)",
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          backgroundImage:
            "radial-gradient(circle at 15% 20%, rgba(179, 166, 210, 0.15) 0, rgba(179, 166, 210, 0.15) 8px, transparent 9px)," +
            "radial-gradient(circle at 85% 30%, rgba(142, 130, 188, 0.12) 0, rgba(142, 130, 188, 0.12) 7px, transparent 8px)",
          backgroundSize: "180px 180px",
          opacity: 0.45,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          inset: { xs: 16, md: 36 },
          borderRadius: 6,
          border: "2px solid rgba(142, 130, 188, 0.35)",
          pointerEvents: "none",
        }}
      />
      <Box
        component="img"
        src="/images/banner1.png"
        alt="Pattern"
        sx={{
          position: "absolute",
          bottom: { xs: -60, md: -100 },
          left: { xs: -80, md: -60 },
          width: { xs: 220, md: 320 },
          opacity: 0.12,
          pointerEvents: "none",
        }}
      />
      <Box
        component="img"
        src="/images/banner3.png"
        alt="Pattern"
        sx={{
          position: "absolute",
          top: { xs: -50, md: -80 },
          right: { xs: -70, md: -40 },
          width: { xs: 200, md: 300 },
          opacity: 0.12,
          pointerEvents: "none",
        }}
      />
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={4}>
          {/* Coluna do Formulário */}
          <Grid item xs={12} md={7}>
            <Box>
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#8E82BC", mb: 1 }}>
                Contáctanos
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
                Envíanos tu mensaje y te responderemos lo antes posible.
              </Typography>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Nombre y Apellidos"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ sx: { fontSize: "12px" } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Teléfono"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      InputLabelProps={{ sx: { fontSize: "12px" } }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Dirección de correo electrónico"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ sx: { fontSize: "12px" } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Asunto"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ sx: { fontSize: "12px" } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      label="Mensaje"
                      name="message"
                      multiline
                      minRows={6}
                      maxRows={10}
                      value={formData.message}
                      onChange={handleChange}
                      required
                      InputLabelProps={{ sx: { fontSize: "12px" } }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{ backgroundColor: "#B3A6D2", color: "white", px: 4, py: 1.2 }}
                    >
                      Enviar
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </Grid>

          {/* Coluna de Informações de Contato */}
          <Grid item xs={12} md={5}>
            <Box sx={{ backgroundColor: "#f8f8f8", borderRadius: 2, p: 3, mt: { xs: 12, md: 16 } }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#8E82BC", mb: 2 }}>
                Estamos en Contacto
              </Typography>
              <Typography variant="body1" sx={{ mb: 3, fontSize: "14px" }}>
                Tienes alguna duda sobre la associación? Quieres ayudar de otra manera? Quieres ser sócio? Escribenos su mensaje!
              </Typography>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: "#8E82BC", mb: 2 }}>
                Nuestros Datos de Contacto
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <LocationOn sx={{ color: "#8E82BC", mr: 1 }} />
                <Typography variant="body1" sx={{ fontSize: "14px" }}>
                  Ciudad: La Bisbal d'Empordà
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Phone sx={{ color: "#8E82BC", mr: 1 }} />
                <Typography variant="body1" sx={{ fontSize: "14px" }}>
                  Teléfono: +34618293661
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Email sx={{ color: "#8E82BC", mr: 1 }} />
                <Typography variant="body1" sx={{ fontSize: "14px" }}>
                  Email: bisbalgat@yahoo.com
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Contact;
